<template>
  <div class="moni-wrap dozuoti-wrap">
    <template v-if="loading">
      <div class="hint">
        <a
          href=""
          v-for="(item, index) in tab"
          v-bind:key="item"
          v-on:click.prevent="tabChange(index)"
          v-bind:class="{ 'hint-active': active === index }"
        >
          {{ item }}
          <span></span>
        </a>
      </div>
      <div
        class="list-box"
        v-for="(item, index) in list[active]"
        v-bind:key="item.id"
      >
        <h1>
          <template v-if="item.sublist">
            <span v-on:click="showListHandle" v-bind:data-index="index">
              <img v-if="!item.isList" src="../../assets/-.png" />
              <img v-else src="../../assets/+.png" />
            </span>
          </template>
          {{ item.name }}
        </h1>
        <template v-if="item.sublist">
          <transition name="fade">
            <ul v-show="!item.isList">
              <li v-for="c in item.sublist" v-bind:key="c.id">
                <p>{{ c.name }}</p>
                <div>
                  <p>{{ c.user_ques_count }}/{{ c.ques_count }}</p>
                  <div class="propress-bar">
                    <span v-bind:style="'width:' + c.accuracy + '%'"></span>
                  </div>
                  <p>准确率:{{ c.accuracy }}%</p>
                </div>
                <a :href="`http://www.xiongsongedu.com/index/center/zhuanxiang?id=${c.id}`"  target="_blank">去做题</a>
              </li>
            </ul>
          </transition>
        </template>
        <template v-else>
          <transition name="fade">
            <ul>
              <li>
                <div>
                  <p>{{ item.user_ques_count }}/{{ item.ques_count }}</p>
                  <div class="propress-bar">
                    <span v-bind:style="'width:' + item.accuracy + '%'"></span>
                  </div>
                  <p>准确率:{{ item.accuracy }}%</p>
                </div>
                <a @click.prevent="toLearnHandle" :href="`http://www.xiongsongedu.com/index/center/zhuanxiang?id=${item.id}`" target="_blank">去做题</a>
              </li>
            </ul>
          </transition>
        </template>
      </div>
    </template>
  </div>
</template>
<script>
import axios from "axios";
import { Loading } from "element-ui";
export default {
  props:{
    stage:Number,   // 做题、结果、解析
  },
  data() {
    return {
      loading: false,
      list: [],
      tab: ["英语", "数学", "逻辑", "写作"],
      active: 0, // 切换索引
    };
  },
  beforeMount() {
    
    // 关闭实例
    this.loadingInstance = Loading.service({
      background: "white",
      text: "加载中...",
      customClass: "colorloadidng",
      target: ".moni-wrap",
    });
    this.loadingInstance.close();
  },
  async mounted() {
    try {
      /*1数学4逻辑15写作16英语二*/
      this.list = await Promise.all([
        this.fetchList("16"),
        this.fetchList("1"),
        this.fetchList("4"),
        this.fetchList("15"),
      ]);
      // 关闭加载层
      this.loadingInstance.close();
      this.loading = true;
      // 页面显示刷新数据
      document.addEventListener("visibilitychange", async ()=> {
              if(document.hidden) {
                this.list = await Promise.all([
                this.fetchList("16"),
                this.fetchList("1"),
                this.fetchList("4"),
                this.fetchList("15"),
            ]);
        }
      });
    } catch (error) {
      console.log(error);
    }
  },
  methods: {
    toLearnHandle(e){
      if (window.uidd) {
        window.location.href = e.currentTarget.getAttribute('href');
      } else {
        window.location.href = document.getElementById('login-d').getAttribute('href');
      }
    },
    // 列表收放e
    showListHandle(e) {
      const index = parseInt(e.currentTarget.dataset.index, 10);
      this.list.splice(
        this.active,
        1,
        this.list[this.active].map((item, i) => {
          if (index === i) {
            item.isList = !item.isList;
          }
          return item;
        })
      );
    },
    // 获取列表
    async fetchList(subject_id) {
      try {
        const res = await axios.get(
          "/m/knowledge/getlist?exam_type=1&subject_id=" + subject_id
        );
        return res.data.data;
      } catch (error) {
        console.log(error);
      }
    },
    // tab切换
    tabChange(index){
      this.active = index;
    }
  },
};

</script>

<style>
.colorloadidng p {
  color: #00b38b !important;
}
.colorloadidng .el-loading-spinner .path {
  stroke: #00b38b;
}
</style>
<style scoped lang="scss">
.moni-wrap {
  .list-box {
    margin-left: 32px;
    margin-top: 45px;
    padding-right: 62px;
    & > h1 {
      font-size: 19px;
      font-weight: 600;
      color: #4b4b4b;
      margin-block-start: 0.67em;
      margin-block-end: 0.67em;
      img {
        margin-right: 4px;
        vertical-align: middle;
      }
    }
    & > ul {
      font-size: 19px;
      padding-inline-start: 40px;
      li {
        display: flex;
        align-items: center;
        justify-content: space-between;
        border-bottom: 1px dotted #d7d7d7;
        & > p {
          flex: 0 230px;
          margin-block-start: 1em;
          margin-block-end: 1em;
        }
        & > div {
          display: flex;
          flex: 0 320px;
          align-items: center;
          
          p {
        
            margin-block-start: 1em;
            margin-block-end: 1em;
          }
        }
        & > div >p:nth-child(1) {
              width: 60px;
            text-align: right;
        }
        a {
          width: 79px;
          height: 28px;
          line-height: 28px;
          text-align: center;
          background-color: #e2f6f1;
          color: #00b38b;
          border-radius: 8px;
          border: solid 1px #00b38b;
          text-decoration: none;
        }
        a:hover {
          text-decoration: underline;
        }
      }
    }
  }
  .hint {
    display: -ms-flexbox;
    display: flex;
    border-bottom: 3px solid #f5f5f5;
  }

  .hint > a {
    font-size: 21px;
    color: #4b4b4b;
    padding: 0 5px;
    width: 50px;
    text-align: center;
    margin-right: 96px;
    line-height: 39px;
    text-decoration: none;
    span {
      display: block;
      width: 28px;
      height: 7px;
      visibility: hidden;
      background-color: #00b38b;
      border-radius: 5px;
      margin: auto;
    }
  }
  .hint > a:hover {
    font-size: 22px;
    color: #4b4b4b;

    //   border-bottom: 3px solid #00b38a;
  }
  .hint .hint-active {
    span {
      visibility: visible;
    }
    //   border-bottom: 3px solid #00b38a;
  }
  .hint h2 {
    line-height: 39px;
    color: #999999;
  }
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.2s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
.propress-bar {
  width: 113px;
  height: 8px;
  background: #e2f6f1;
  border-radius: 10px;
  overflow: hidden;
  span {
    display: block;
    background: #00b38a;
    height: 100%;
  }
  margin-left: 12px;
  margin-right: 12px;
}
</style>